mutation startBackgroundMaskJob($sourceImageKey: String!) {
  startBackgroundMaskJob(sourceImageKey: $sourceImageKey) {
    id
  }
}
